import React from 'react'
import Breadcrumbs from '@components/Breadcrumbs'
import withForceLogin from '@helpers/auth/withForceLogin'
import withWebsiteId from '@helpers/websites/withWebsiteId'
import Container from '@packages/justo-parts/lib/components/Container'
import withGraphQL from '@packages/react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import {TFunction, withTranslation} from 'next-i18next'

import Order from './Order'

import styles from './styles.module.css'

export const FINISHED_STATUSES = ['done', 'cancelled']

export interface OrdersProps {
  t: TFunction
  me?: any
}
@withWebsiteId
@withGraphQL(gql`
  query getMyOrders($websiteId: ID) {
    me {
      _id
      orders(websiteId: $websiteId) {
        _id
        code
        isScheduled
        isConfirmed
        createdAt
        orderStatus
        paymentStatus
        totalPrice
        review {
          _id
          rating
        }
        productsResume
        items {
          amount
          product {
            _id
            name
            images {
              _id
              url
            }
          }
        }
      }
    }
  }
`)
class Orders extends React.Component<OrdersProps> {
  renderOrder(order) {
    return (
      <div key={order._id} className="col-xs-12 col-sm-6">
        <Order order={order} />
      </div>
    )
  }

  render() {
    const orders = this.props.me.orders || []
    const finishedOrders = orders.filter(order => FINISHED_STATUSES.includes(order.orderStatus))

    const unfinishedOrders = orders.filter(order => !FINISHED_STATUSES.includes(order.orderStatus))
    const scheduledOrders = unfinishedOrders.filter(order => order.isScheduled)
    const activeOrders = unfinishedOrders.filter(order => !order.isScheduled)

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <Breadcrumbs>{this.props.t('fields.myOrders')}</Breadcrumbs>
        </div>
        <div className="divider" />
        {activeOrders.length ? (
          <Container className={styles.ordersContainer}>
            <h2>{this.props.t('fields.activeOrders')}</h2>
            <div className="row">{activeOrders.map(this.renderOrder)}</div>
          </Container>
        ) : null}
        {scheduledOrders.length ? (
          <Container className={styles.ordersContainer}>
            <h2>{this.props.t('fields.scheduledOrders')}</h2>
            <div className="row">{scheduledOrders.map(this.renderOrder)}</div>
          </Container>
        ) : null}
        {finishedOrders.length ? (
          <Container className={styles.ordersContainer}>
            <h2>{this.props.t('fields.finishedOrders')}</h2>
            <div className="row">{finishedOrders.map(this.renderOrder)}</div>
          </Container>
        ) : null}
      </div>
    )
  }
}

export default withForceLogin(withTranslation('generic')(Orders))
